import { flowsSelectors } from '@polyai/stream/store/reducers/flows';

import { useAppSelector } from 'hooks/reduxHooks';

const useFlowsState = () => {
  const flows = useAppSelector(state =>
    flowsSelectors.selectAll(state.flows.flows),
  );
  return { flows };
};

export default useFlowsState;
